var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 7.5C13.7842 7.5 11.25 10.0342 11.25 13.125V48.75H12.041C12.8613 50.8301 14.5166 52.5 16.875 52.5H48.75V48.75H16.875C15.8203 48.75 15 47.9297 15 46.875C15 45.8203 15.8203 45 16.875 45H48.75V7.5H16.875ZM16.875 11.25H45V41.25H16.875C16.2158 41.25 15.5859 41.3965 15 41.6016V13.125C15 12.0703 15.8203 11.25 16.875 11.25ZM18.75 18.75V22.5H41.25V18.75H18.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI5);
export default __webpack_public_path__ + "static/media/i5.bd3136c81ac511cd4c2e7a060970ce6e.svg";
export { ForwardRef as ReactComponent };